"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuthenticationLink = void 0;
const context_1 = require("@apollo/client/link/context");
const createAuthenticationLink = (getToken) => (0, context_1.setContext)(async (_, { headers }) => {
    const headersWithAuth = {};
    const token = await getToken();
    if (token) {
        headersWithAuth.Authorization = `Bearer ${token}`;
    }
    return {
        headers: {
            ...headers,
            ...headersWithAuth,
        },
    };
});
exports.createAuthenticationLink = createAuthenticationLink;
//# sourceMappingURL=authenticationLink.js.map